import React, { useMemo } from "react";
import {
    GraphProps, getMetricValue, filter, formatValueWithDisplay,
} from "./base";
import { MetricsDashboardGraphTypeDisplayType } from "../../../__generated__/api";

export default function CountChart(props: GraphProps) {
    const textValue = useMemo(() => {
        const metric = props.graph.metrics?.firstElement;
        const fieldIndex = props.data.columns.findIndex(row => row.id === metric?.fieldId);

        const dataRows = filter(props.data.rows, props.graph.filters, props.columnIndexMap);
        const values = dataRows.map(row => row.values[fieldIndex]).filter(row => row != null && row !== "") as string[];
        const value = getMetricValue(values, metric?.aggregation);

        const display = metric?.display ?? MetricsDashboardGraphTypeDisplayType.Number;

        return formatValueWithDisplay(value, display);
    }, [props.data]);

    return (
        <div>
            <small className="text-gray-500">{props.graph.title}</small>
            <h4 className="text-blue-dark text-center">
                {textValue}
            </h4>

        </div>
    );
}
